import { lazy } from "@redotech/util/cache";

export const cssStylesheetSupport: () => boolean = lazy(() => {
  try {
    new CSSStyleSheet(); // Safari does not support before 16.4
  } catch {
    return false;
  }
  return true;
});
